import * as React from 'react';
import parse from 'html-react-parser';
// import { DrawerTooltipContent } from '../../modals/drawerModal/types';
// import Tooltip from '../../modals/tooltip';
import { Theme } from '../../../../../theme/types';

// import WithCoreProps from '../../../hocs/withCoreProps';
// import CoreHelper from '../../../helpers/coreHelper';
import { WithCoreProps, CoreHelper } from 'ff-shared-components-core';

import defaultTheme from '../../../../../theme/defaultTheme';
import { TitleStyled } from './styles';

interface JourneyTitleProps {
	/** Text to be shown */
	title?: any;
	titleRender?: () => JSX.Element;
	/** Set Title to be white */
	white?: boolean;
	/** Set Title to be on center */
	center?: boolean;
	/** Set Title to be full width */
	fullWidth?: boolean;
	/** Set Title to have id1 Font and Size */
	id1?: boolean;
	/** Set Title to have id2 Font and Size */
	id2?: boolean;
	/** Set Title to have id3 Font and Size */
	id3?: boolean;
	/** Set Title to have id4 Font and Size */
	id4?: boolean;
	/** Set Title to have id5 Font and Size */
	id5?: boolean;
	/** Set Title to have id6 Font and Size */
	id6?: boolean;
	/** Set Title to have id7 Font and Size */
	id7?: boolean;
	/** Set Title to have id8 Font and Size */
	id8?: boolean;
	/** Set Title to have id9 Font and Size */
	id9?: boolean;
	/** Set Title to have id10 Font and Size */
	id10?: boolean;
	/** Set Title to have id11 Font and Size */
	id11?: boolean;
	/** Set Title to have id12 Font and Size */
	id12?: boolean;
	/** Set Title to have id13 Font and Size */
	id13?: boolean;
	/** Set Title to have id14 Font and Size */
	id14?: boolean;
	/** Set Title to have id15 Font and Size */
	id15?: boolean;
	/** Set Title to have id16 Font and Size */
	id16?: boolean;
	/** Set Title to have id17 Font and Size */
	id17?: boolean;
	/** Set Title to have id18 Font and Size */
	id18?: boolean;
	/** Set Title to have border bottom */
	borderBottom?: boolean;
	/** Set Title to be bold */
	bold?: boolean;
	/** Set Title to have light font */
	light?: boolean;
	appearance?: string;
	/** Set Title Margin Top */
	marginTop?: number;
	/** Set Title Margin Bottom */
	marginBottom?: number;
	/** Set Title Margin Left */
	marginLeft?: string;
	/** Set Title to Have Tooltip */
	// tooltip?: DrawerTooltipContent;
	/** Set Title Width */
	width?: number;
	/** Set Title color */
	color?: string;
}

interface InjectedProps {
	theme: Theme;
}

export interface JourneyTitleStylesProps extends JourneyTitleProps {
	theme: Theme;
}

const JourneyTitle = (props: JourneyTitleProps & InjectedProps): JSX.Element => {
	const { title, titleRender, /*tooltip,*/ theme: propsTheme } = props;
	const theme = CoreHelper.mergeObjects(defaultTheme, propsTheme);

	const contentText = title || (titleRender && titleRender()) || '';

	return (
		<TitleStyled {...props} theme={theme}>
			<div>{parse(contentText)}</div>

			{/* {tooltip && (
				<Tooltip
					title={tooltip.title}
					description={tooltip.description}
					withoutIcon={tooltip.withoutIcon}
					changeEventOnClick={tooltip.onclickEvent}
					lockScreenScrollOnModalOpen={tooltip.lockScreenScrollOnModalOpen}
				/>
			)} */}
		</TitleStyled>
	);
};

export default WithCoreProps<JourneyTitleProps>(JourneyTitle);
